import angular from 'angular';

/** data */
import booksData from './data/data';
import accountType from './data/AccountType/AccountType';
import ledgerItemOption from './data/ledgerItemOption/ledgerItemOption';

/** dialogs */
import addChangeClassDialog from './dialogs/addChangeClassDialog/addChangeClassDialog';
import addChangeFundraiserDialog from './dialogs/addChangeFundraiserDialog/addChangeFundraiserDialog';
import addInvoiceDialog from './dialogs/AddInvoiceDialog/AddInvoiceDialog';
import addChangeEntityDialog from './dialogs/entities/addChangeEntityDialog/addChangeEntityDialog';
import addChangeStudentDialog from './dialogs/entities/addChangeStudentDialog/addChangeStudentDialog';
import addChangeVendorDialog from './dialogs/entities/addChangeVendorDialog/addChangeVendorDialog';
import mergeEntityDialog from './dialogs/entities/mergeEntityDialog/mergeEntityDialog';
import openDocumentsDialog from './dialogs/OpenDocumentsDialog/OpenDocumentsDialog';
import overdrawnItemsDialog from './dialogs/OverdrawnItemsDialog/OverdrawnItemsDialog';
import unpaidPurchaseOrdersDialog from './dialogs/UnpaidPurchaseOrdersDialog/UnpaidPurchaseOrdersDialog';

/** ui */
import genderSelect from './ui/genderSelect/genderSelect';
import accountActivityReport from './ui/accountActivityReport/accountActivityReport';
import accountSelector from './ui/accountSelector/accountSelector';
import accountStatementReport from './ui/accountStatementReport/accountStatementReport';
import addInventoryItem from './ui/addInventoryItem/addInventoryItem';
import balanceSheet from './ui/balanceSheet/balanceSheet';
import csmGrid from './ui/csmGrid/csmGrid';
import donationsReport from './ui/donationsReport/donationsReport';
import entitySelection from './ui/entitySelection/entitySelection';
import fundraiserReport from './ui/fundraiserReport/fundraiserReport';
import incomeStatement from './ui/incomeStatement/incomeStatement';
import inventoryProducts from './ui/inventoryProducts/inventoryProducts';
import productItemOptionsList from './ui/productItemOptionsList/productItemOptionsList';
import inventoryReport from './ui/inventoryReport/inventoryReport';
import invoiceItems from './ui/invoiceItems/invoiceItems';
import invoiceVendor from './ui/invoiceVendor/invoiceVendor';
import itemOptionsReport from './ui/itemOptionsReport/itemOptionsReport';
import itemSalesReport from './ui/itemSalesReport/itemSalesReport';
import itemSummaryReport from './ui/itemSummaryReport/itemSummaryReport';
import productOptionsList from './ui/productOptionsList/productOptionsList';
import storeItems from './ui/storeItems/storeItems';
import tagIndicator from './ui/tagIndicator/tagIndicator';
import toggleButtons from './ui/toggleButtons/toggleButtons';
import transactionDetail from './ui/transactionDetail/transactionDetail';
import transactionSummary from './ui/transactionSummary/transactionSummary';
import trialBalance from './ui/trialBalance/trialBalance';
import vendor1099Report from './ui/vendor1099Report/vendor1099Report';

/** util */
import barCodeValidator from './util/BarcodeValidator/BarcodeValidator';
import booksSettings from './util/BooksSettings/BooksSettings';
import booksSvc from './util/BooksSvc/BooksSvc';
import dgProductPurchase from './util/DGProductPurchase/DGProductPurchase';
import distributionSpec from './util/DistributionSpec/DistributionSpec';
import invoiceService from './util/InvoiceService/InvoiceService';
import entityMaker from './util/entityMaker/entityMaker';
import productUtils from './util/ProductUtils/ProductUtils';
import vendorsTypeAhead from './util/vendors/typeahead/typeahead';
import util from './util/util';

export default angular.module('CSMBooksWeb', [
  /* Data */
  booksData,
  accountType,
  ledgerItemOption,

  /** Dialogs */
  addChangeClassDialog,
  addChangeFundraiserDialog,
  addInvoiceDialog,
  addChangeEntityDialog,
  addChangeStudentDialog,
  addChangeVendorDialog,
  mergeEntityDialog,
  openDocumentsDialog,
  overdrawnItemsDialog,
  unpaidPurchaseOrdersDialog,

  /** Ui */
  genderSelect,
  accountActivityReport,
  accountSelector,
  accountStatementReport,
  addInventoryItem,
  balanceSheet,
  csmGrid,
  donationsReport,
  entitySelection,
  fundraiserReport,
  incomeStatement,
  inventoryProducts,
  inventoryReport,
  invoiceItems,
  invoiceVendor,
  itemOptionsReport,
  itemSalesReport,
  itemSummaryReport,
  productItemOptionsList,
  productOptionsList,
  storeItems,
  tagIndicator,
  toggleButtons,
  transactionDetail,
  transactionSummary,
  trialBalance,
  vendor1099Report,

  /** Util */
  barCodeValidator,
  booksSettings,
  booksSvc,
  dgProductPurchase,
  distributionSpec,
  invoiceService,
  entityMaker,
  productUtils,
  vendorsTypeAhead,
  util
]).name;